import React from 'react'
import removeMarkdown from 'remove-markdown'

import { isColorBackground } from '../../util'

import CTAButton from '../CTA/cta'
import Markdown from '../Markdown/markdown'

import './dual-box.scss'


class DualBox extends React.Component {

  copyToClipboard = this.copyToClipboard.bind(this)

  copyToClipboard(content) {
    const plainContent = removeMarkdown(content)
    const txt = document.createTextNode(plainContent)
    document.body.appendChild(txt)

    if (document.body.createTextRange) {
      const d = document.body.createTextRange()

      d.moveToElementText(txt)
      d.select()
      document.execCommand('copy')
    } else {
        const d = document.createRange()

        d.selectNodeContents(txt)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(d)
        document.execCommand('copy')
        window.getSelection().removeAllRanges()
    }

    txt.remove()
  }

  renderPanel(panel) {
    const ctas = panel.ctaButtons ? panel.ctaButtons.map((cta, i) => {
      const url = cta.url
      const onClick = url === '#copyToClipboard' ? 
        () => this.copyToClipboard(panel.body.body) : null
      const style = cta.style

      return (
        <div className="button-container" key={ i }>
          <CTAButton title={ cta.title } url={ url } onClick={ onClick } style={ style }/>
        </div>
      )
    }) : []

    const additionalClass = isColorBackground(panel.backgroundColor) ? 'color-background' : ''

    return (
      <div 
        className={ `panel-container ${additionalClass}` } 
        style={{ 'backgroundColor': panel.backgroundColor }}>
        <h3>{ panel.heading }</h3>
        <div className="panel-content">
          <Markdown content={ panel.body.body } />

          { ctas.length > 0 ? 
            <div className="button-container">
              { ctas }
            </div> : null }
        </div>

      </div>
    )
  }


  render() {
    const { leftPanel, rightPanel } = this.props.content

    return (
      <div className="dualbox-container standard-container">
        { this.renderPanel(leftPanel) }
        { this.renderPanel(rightPanel) }
      </div>
    )
  }
}

export default DualBox


// WEBPACK FOOTER //
// ./src/components/DualBox/dual-box.js